import { render, staticRenderFns } from "./OpenNotifications.vue?vue&type=template&id=7c624b08&"
import script from "./OpenNotifications.vue?vue&type=script&lang=ts&"
export * from "./OpenNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./OpenNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports